module.exports = __webpack_public_path__ + "img/10.6afe5bdc.jpg";